import type { SxProps, Theme } from '@mui/material/styles';

import { signupPageStyles, signupTypography } from '../../../pages/signup/SignupPage/SignupPage.styles';

export const signupSchoolFinderStyles = {
  input: signupPageStyles.input,
  fieldGroup: signupPageStyles.fieldGroup,
  continueButton: signupPageStyles.continueButton,
  inlineAction: signupPageStyles.inlineAction,
  fieldLabel: (): SxProps<Theme> => ({
    display: 'block',
    mb: 1.25,
    fontSize: signupTypography.standard,
    fontWeight: 500,
  }),
  menuItem: (): SxProps<Theme> => ({
    fontSize: signupTypography.standard,
  }),
  zipRow: (): SxProps<Theme> => ({
    display: 'grid',
    minWidth: 0,
    gridTemplateColumns: { xs: '1fr', sm: 'minmax(0, 1fr) auto' },
    gap: 1.5,
    alignItems: 'stretch',
  }),
  helperText: (theme: Theme): SxProps<Theme> => ({
    mt: 1,
    color: theme.palette.grey[700],
    fontSize: signupTypography.supporting,
    lineHeight: 1.45,
  }),
  schoolLookupError: (theme: Theme): SxProps<Theme> => ({
    mt: 1,
    color: theme.palette.error.main,
    fontSize: signupTypography.supporting,
    lineHeight: 1.45,
  }),
  completionError: (theme: Theme): SxProps<Theme> => ({
    mt: 2,
    color: theme.palette.error.main,
    fontSize: signupTypography.supporting,
    lineHeight: 1.45,
  }),
  missingSchoolPanel: (): SxProps<Theme> => ({
    display: 'grid',
    gap: 2.5,
    mt: 1.5,
  }),
  missingSchoolMessage: (theme: Theme): SxProps<Theme> => ({
    color: theme.palette.grey[700],
    fontSize: signupTypography.standard,
    lineHeight: 1.5,
  }),
  stateLookupError: (): SxProps<Theme> => ({
    display: 'flex',
    alignItems: 'baseline',
    gap: 1,
    flexWrap: 'wrap',
  }),
  stepHeading: (): SxProps<Theme> => ({
    mt: 3,
    mb: 2,
    fontSize: signupTypography.sectionHeading,
    fontWeight: 400,
  }),
  schoolList: (): SxProps<Theme> => ({
    display: 'grid',
    gap: 1,
  }),
  schoolOption: (theme: Theme, isSelected: boolean): SxProps<Theme> => ({
    width: '100%',
    minHeight: '68px',
    m: 0,
    px: 1.25,
    py: 0.75,
    border: `1px solid ${isSelected ? '#0090fa' : theme.palette.divider}`,
    borderRadius: 1,
    bgcolor: isSelected ? 'rgba(0, 144, 250, 0.08)' : theme.palette.background.paper,
    '&:focus-within': {
      outline: '3px solid rgba(0, 144, 250, 0.25)',
      outlineOffset: '2px',
    },
  }),
  schoolName: (): SxProps<Theme> => ({
    fontSize: signupTypography.standard,
    lineHeight: 1.35,
  }),
  schoolAddress: (theme: Theme): SxProps<Theme> => ({
    color: theme.palette.grey[700],
    fontSize: signupTypography.supporting,
    lineHeight: 1.35,
  }),
  schoolActions: (): SxProps<Theme> => ({
    display: 'flex',
    alignItems: { xs: 'stretch', sm: 'center' },
    gap: { xs: 2, sm: 3 },
    mt: 2.5,
    flexDirection: { xs: 'column', sm: 'row' },
  }),
};
